import { NumberValue } from '@heroui-pro/react';
import { gelNumberOf } from '@/utils';

type TransactionAmountProps = { amountTetri: number; minus?: boolean };

/** Receipt and transaction money: two decimal places, without a currency symbol. */
export const TransactionAmount = ({
    amountTetri,
    minus = false,
}: TransactionAmountProps) => (
    <NumberValue
        style="decimal"
        value={gelNumberOf(amountTetri)}
        minimumFractionDigits={2}
        maximumFractionDigits={2}
    >
        {minus && <NumberValue.Prefix>−</NumberValue.Prefix>}
    </NumberValue>
);
